import { StorageService } from '@/services';
import { FileModel, PaginationType, RootModel } from '@/types';
import { createModel } from '@rematch/core';
import baseEntity from './base.entity';

interface StorageStateType {
  ids: { [id: number]: FileModel };
}

export const storageEntities = createModel<RootModel>()({
  state: { ids: {} } as StorageStateType,
  reducers: {
    ...baseEntity,
  },
  effects: () => ({
    async load(payload): Promise<{ content: FileModel[] } & PaginationType> {
      try {
        const res = await StorageService.filterStorages(payload);
        const { content } = res.data;
        if (content && content.length) {
          this.saveSimplified(content);
        }
        return res.data;
      } catch (e: any) {
        throw new Error(e);
      }
    },
    async save(payload) {
      try {
        let item;
        const { id } = payload;
        if (id) {
          ({ data: item } = await StorageService.updateStorage(payload));
        } else {
          ({ data: item } = await StorageService.createStorage(payload));
        }

        this.update(item);
        return item;
      } catch (e: any) {
        throw new Error(e);
      }
    },
    async delete(payload) {
      try {
        await StorageService.deleteById(payload);
        this.remove({ id: payload });
      } catch (e: any) {
        throw new Error(e);
      }
    },
  }),
});
